import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbListaConvidados } from 'app/abstract/full-pages/lista-convidados/lista-convidados.abstract';
import { AppFilter } from 'app/models/app-filter.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ListaConvidadosService extends AbListaConvidados {

  constructor(http: HttpClient) {
    super(http);
  }


  public getListasConvidadosFilter(filter: AppFilter): Observable<any> {
    return this.get(`lista_convidados/filter/${filter.encode()}`);
  }

  public salvarListaConvidados(entity) {
    return this.save("lista_convidados/", entity);
  }

  public getListaConvidados(id) {
    return this.get("lista_convidados/", id);
  }

  public deleteListaConvidados(id) {
    return this.delete("lista_convidados/", id);
  }

  public deleteVisitanteListaConvidados(id) {
    return this.delete("lista_convidados/visitante_lista_convidados/", id);
  }

}
